// src/components/PdfWhiteboard/constants/drawingTools.js
export const TOOLS = {
  SELECT: 'SELECT',
  PEN: 'PEN',
  RECTANGLE: 'RECTANGLE',
  CIRCLE: 'CIRCLE',
  LINE: 'LINE',
  MEASURE: 'MEASURE',
  POINT: 'POINT',
  POLYLINE: 'POLYLINE',
  POLYGON: 'AREA',
  AREA: 'AREA',
  TEXT: 'TEXT',
  MEASUREMENT_SUMMARY: 'MEASUREMENT_SUMMARY',
  COTATION: 'COTATION',
  ARROW: 'ARROW',
};

// Supported point marker shapes. Old shapes without a pointMarker field default to 'disk'.
export const POINT_MARKERS = {
  disk:     { label: 'Disk' },
  square:   { label: 'Square' },
  triangle: { label: 'Triangle' },
  diamond:  { label: 'Diamond' },
  cross:    { label: 'Cross' },
  star:     { label: 'Star' },
};

export const BOOLEAN_OPERATIONS = {
  UNION: 'union',
  INTERSECTION: 'intersection',
  DIFFERENCE: 'difference',
  XOR: 'xor'
};